import './modal-onbording.scss';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import Button from '../../atoms/button/button';

const ModalOnbording = (props) => {
    const { modalContent } = props;

    return (
        <div className="modal-onbording">
            <div className="modal-onbording__content">
                <div className="modal-onbording__title">
                    <p>{modalContent.nombre}</p>
                    <img
                        src={modalContent.imagen[0].file.url}
                        alt={modalContent.imagen[0].file.title}
                    />
                </div>
                <div className="modal-onbording__description">
                    {modalContent.descripcion &&
                        documentToReactComponents(
                            JSON.parse(modalContent.descripcion.raw)
                        )}
                </div>
                <Button
                    type="button"
                    classname="modal-onbording__button secondary"
                    text={modalContent.referencias[0].copyBoton}
                    onClickAction={() => props.onClose()}
                    isDisabled={false}
                />
            </div>
        </div>
    );
};

export default ModalOnbording;
